module.exports = __webpack_public_path__ + "img/container.356993bd.png";